module.exports = __webpack_public_path__ + "static/media/icon-export.0f50492c.svg";